// extracted by mini-css-extract-plugin
export default {"casts":"CastsList_casts__XyHhF","img":"CastsList_img__v2iaK","name":"CastsList_name__k-JdV"};